import React, { useCallback, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import api from '../../../../middleware/api';
import PortalModal from '../../../Common/Modal/PortalModal';
import { formatDefaultConfigurationToAddCapsule } from '../../../../utils/capsule_configuration.utils';

const UpdateBatchSensibilityAndDilutionModal = React.forwardRef(({ selectedItem, selectedConfigurationId, defaultCapsule, setCapsuleConfiguration }, ref) => {
    const [editValues, setEditValues] = useState({ sensibility: '', dilution: '' });
    const [availableDilutions, setAvailableDilutions] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleEditChange = useCallback((field, value) => {
        setEditValues(prev => ({
            ...prev,
            [field]: value
        }));
    }, []);

    const handleEditSubmit = useCallback(async (e) => {
        e.preventDefault();
        try {
            const mixtureIds = selectedItem.map(item => item.mixture.id);
            const response = await api.put(`/capsules/configurations/update/batch/sensibility-dilution/${selectedConfigurationId}`, {
                mixtureIds,
                sensibility: editValues.sensibility || null,
                dilution: availableDilutions.find(dilution => dilution.id === Number(editValues.dilution)) || null 
            });
            if (response.status === 200) {
                const updatedCapsule = formatDefaultConfigurationToAddCapsule(response.data.configuration, defaultCapsule.name, defaultCapsule.id);
                setCapsuleConfiguration(updatedCapsule);
                toast.success('Les paramètres ont été mis à jour avec succès');
            }
        } catch (e) {
            console.error(e);
            toast.error('Une erreur s\'est produite lors de la mise à jour des paramètres');
        }
        ref.current?.hideModal();
    }, [editValues, selectedItem, selectedConfigurationId, defaultCapsule.name, defaultCapsule.id]);

    useEffect(() => {
        const fetchDilutions = async () => {
            try {
                const response = await api.get('/dilutions');
                if (response.status === 200) {
                    setAvailableDilutions(response.data.values);
                }
            } catch (e) {
                console.error(e);
                toast.error('Une erreur s\'est produite lors de la récupération des dilutions');
            } finally {
                setLoading(false);
            }
        };

        fetchDilutions();
    }, []);

    return (
        <PortalModal ref={ref}>
            <form onSubmit={handleEditSubmit} className='p-4'>
                <h1 className='text-xl font-bold mb-4'>Appliquer les paramètres</h1>
                <div className='mt-6'>
                    <h2 className='text-base font-bold mb-2'>Éléments sélectionnés :</h2>
                    <div className='flex flex-row flex-wrap justify-between gap-y-2'>
                        {selectedItem.map((item, index) => (
                            <div key={index} className='mt-2 p-2 border border-gray-200 rounded-md'>
                                <span className={`font-bold ${item.mixture.category === 'Effluences' ? 'text-accent' : ''}`}>{item.mixture.name}</span>
                                <div className='text-sm text-gray-600'>
                                    Sensibilité : {item?.sensibility || 'N/A'} {editValues.sensibility && `→ ${editValues.sensibility}`}
                                </div>
                                <div className='text-sm text-gray-600'>
                                    Dilution : {item?.dilution?.label || 'N/A'} {editValues.dilution && `→ ${editValues.dilution}`}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='flex flex-row flex-wrap gap-y-4'>
                    <select
                        className='form-select border border-gray-300 rounded-md p-2'
                        onChange={(e) => handleEditChange('sensibility', e.target.value)}
                        value={editValues.sensibility}
                    >
                        <option value=''>Sensibilité</option>
                        {[1, 2, 3, 4, 5].map(value => (
                            <option key={value} value={value.toString()}>{value}</option>
                        ))}
                    </select>
                    <select
                        className='form-select border border-gray-300 rounded-md p-2'
                        onChange={(e) => handleEditChange('dilution', e.target.value)}
                        value={editValues.dilution}
                    >
                        <option value=''>Dilution</option>
                        {availableDilutions.map(dilution => (
                            <option key={dilution.id} value={dilution.id}>{dilution.label}</option>
                        ))}
                    </select>
                </div>
                <div className='flex flex-row flex-wrap justify-center gap-4 mt-4'>
                    <button type="submit" className='btn btn-primary max-w-24 min-w-24 rounded-md p-2 '>Appliquer</button>
                    <button type="button" className='btn btn-error text-white max-w-24 min-w-24 rounded-md p-2 ' onClick={() => ref.current?.hideModal()}>Annuler</button>
                </div>
            </form>
        </PortalModal>
    );
});

export default UpdateBatchSensibilityAndDilutionModal;
